import { CustomerAssetTransactions } from '@src/containers/Dealer/CustomerAssetTransactions/CustomerAssetTransactions';
import type { CustomerAssetTransactionsPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

export function CustomerAssetTransactionsPanel({
  api,
  params,
}: LayoutPanelProps<CustomerAssetTransactionsPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-asset-transactions-panel"
    >
      <CustomerAssetTransactions />
    </EntityAdminPanelShell>
  );
}
